<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
const { t } = useI18n()
</script>

<template>
  <footer class="site-footer">
    <div class="site-footer__top">
      <RouterLink class="site-brand" to="/"><span class="site-brand__mark" aria-hidden="true"><i></i><b></b></span><span><strong>MOTEXA</strong><small>RIDE / FIELD NOTES</small></span></RouterLink>
      <p>{{ t('footer.line') }}</p>
      <div class="site-footer__links"><RouterLink to="/privacy">{{ t('footer.privacy') }}</RouterLink><RouterLink to="/about">{{ t('footer.about') }}</RouterLink><a href="/licenses/threeui/LICENSE" target="_blank">ThreeUI license ↗</a><a href="https://github.com/MengTo/threeui" rel="noreferrer">ThreeUI ↗</a></div>
    </div>
    <div class="site-footer__base"><span>{{ t('footer.copyright') }}</span><span>BLE · WebGL · Open source</span></div>
  </footer>
</template>
